import { configureStore } from "@reduxjs/toolkit";
import { Provider } from "react-redux";
import rootReducer from "./rootReducer";
import React from "react";

export const store = configureStore({
	reducer: rootReducer,
	middleware: (getDefaultMiddleware) =>
		getDefaultMiddleware({
			serializableCheck: false,
			immutableCheck: false,
		}),

	devTools: process.env.NODE_ENV !== "production",
});

const ReduxProvider = ({ children }) => {
	return (
		<Provider store={store}>
			<div>{children}</div>{" "}
		</Provider>
	);
};

export default ReduxProvider;
